"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plane = void 0;
const gl_matrix_1 = require("gl-matrix");
class Plane {
    constructor(_vector_u = gl_matrix_1.vec3.fromValues(0, 1, 0), _vector_v = gl_matrix_1.vec3.fromValues(0, 0, 1), _constant = 0) {
        this._vector_u = _vector_u;
        this._vector_v = _vector_v;
        this._constant = _constant;
        this._normal = gl_matrix_1.vec3.fromValues(1, 0, 0);
        this._normal = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), this._vector_u, this._vector_v));
    }
    get constant() {
        return this._constant;
    }
    set constant(value) {
        this._constant = value;
    }
    get normal() {
        return this._normal;
    }
    set normal(value) {
        this._normal = value;
    }
    get vector_u() {
        return this._vector_u;
    }
    set vector_u(value) {
        this._vector_u = value;
    }
    get vector_v() {
        return this._vector_v;
    }
    set vector_v(value) {
        this._vector_v = value;
    }
    applyMatrix(matrix) {
        const upperLeft = gl_matrix_1.mat3.fromMat4(gl_matrix_1.mat3.create(), matrix);
        let inverse = gl_matrix_1.mat3.invert(gl_matrix_1.mat3.create(), upperLeft);
        if (!inverse)
            inverse = gl_matrix_1.mat3.create();
        const normalMatrix = gl_matrix_1.mat3.transpose(gl_matrix_1.mat3.create(), inverse);
        const p = gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.clone(this.normal), gl_matrix_1.vec3.fromValues(this._constant, this._constant, this._constant)), matrix);
        this._normal = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), this._normal, normalMatrix));
        this._vector_u = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), this._vector_u, upperLeft));
        this._vector_v = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), this._vector_v, upperLeft));
        this.constant = -gl_matrix_1.vec3.dot(p, this._normal);
        return this;
    }
    clampPoint(point) {
        const d = -this.distanceToPoint(point);
        return gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.multiply(gl_matrix_1.vec3.create(), this.normal, gl_matrix_1.vec3.fromValues(d, d, d)), point);
    }
    clone() {
        return new Plane(gl_matrix_1.vec3.clone(this._vector_u), gl_matrix_1.vec3.clone(this._vector_v), this._constant);
    }
    containsPoint(point) {
        return this.distanceToPoint(point) === 0;
    }
    convertFromLSToWS(point) {
        const origin = gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), this._normal, -this._constant);
        return gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), origin, gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), this._vector_u, point[0])), gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), this._vector_v, point[1])), gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), this._normal, point[2]));
    }
    convertFromWSToLS(point, project = true) {
        const origin = gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), this._normal, -this._constant);
        const d = gl_matrix_1.vec3.subtract(gl_matrix_1.vec3.create(), point, origin);
        return gl_matrix_1.vec3.fromValues(gl_matrix_1.vec3.dot(d, this._vector_u), gl_matrix_1.vec3.dot(d, this._vector_v), project ? 0 : gl_matrix_1.vec3.dot(d, this._normal));
    }
    distanceToPoint(point) {
        return gl_matrix_1.vec3.dot(this.normal, point) + this.constant;
    }
    intersect(origin, direction) {
        const denominator = gl_matrix_1.vec3.dot(this.normal, direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(origin) === 0)
                return 0;
            return null;
        }
        const t = -(gl_matrix_1.vec3.dot(origin, this.normal) + this.constant) / denominator;
        if (t < 0)
            return null;
        return t;
    }
    reset() {
        this._normal = gl_matrix_1.vec3.fromValues(1, 0, 0);
        this._vector_u = gl_matrix_1.vec3.fromValues(0, 1, 0);
        this._vector_v = gl_matrix_1.vec3.fromValues(0, 0, 1);
        this._constant = 0;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        gl_matrix_1.vec3.copy(this._normal, normal);
        const up = Math.abs(normal[1]) < 0.9
            ? gl_matrix_1.vec3.fromValues(0, 1, 0)
            : gl_matrix_1.vec3.fromValues(1, 0, 0);
        this._vector_u = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), up, normal));
        this._vector_v = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), normal, this._vector_u));
        this.constant = -gl_matrix_1.vec3.dot(point, this._normal);
        return this;
    }
}
exports.Plane = Plane;
//# sourceMappingURL=Plane.js.map